module.exports = __webpack_public_path__ + "img/img21.f8554980.jpg";